import { cn } from "@/lib/utils";

export interface KbdProps
  extends Omit<React.ComponentProps<"kbd">, "children" | "className"> {
  /** Keyboard shortcut text. */
  children: string;
}

/**
 * Keyboard shortcut badge.
 *
 * @example
 * <Kbd>⌘I</Kbd>
 * <Kbd>Shift</Kbd>
 */
function Kbd({ children, ...props }: KbdProps) {
  return (
    <kbd
      data-slot="kbd"
      className={cn(
        "inline-flex",
        "items-center",
        "justify-center",
        "gap-(--spacing-4)",
        "rounded-(--radius-sm)",
        "border-[0.5px]",
        "border-solid",
        "border-menu-hotkey-outline",
        "bg-menu-hotkey-background",
        "px-(--spacing-6)",
        "py-(--spacing-4)",
        "font-(family-name:--font-family-body)",
        "text-(length:--font-size-label-medium)",
        "font-(number:--font-weight-regular)",
        "leading-(--font-line-height-16)",
        "tracking-(--font-letter-spacing-default)",
        "text-surface-on-surface-variant",
        "whitespace-nowrap",
        "not-italic",
        "select-none",
      )}
      {...props}
    >
      {children}
    </kbd>
  );
}

export { Kbd };
